import { EntityService, HttpClient } from "@elotech/angular-common";
import { inject, Injectable } from "@angular/core";
import { S3Service } from "./s3.service";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class FileService extends EntityService<any>{
  private _s3Service = inject(S3Service);

  constructor(public httpclient: HttpClient) {
    super(httpclient);
    this.resource = '/api/files';
  }

  getPresignedDownloadUrl(fileKey: string, secure: boolean) {
    return this.httpClient.get({resource: `${this.resource}/url-presigned?fileKey=${fileKey}&secure=${secure}`});
  }

  getArquivoS3(urlSafe: any): Observable<Blob> {
    return this._s3Service.getArquivoS3(urlSafe);
  }
}
